import MaintenancePage from "../MaintenancePage";
import resource from "../../resources/leaveTypeResource";

export default function LeaveTypes() {
    return <MaintenancePage resource={resource} />;
}
